import { createPartnerUser } from "@redotech/admin-sdk/rpc/schema/partners/create-partner-user";
import { Flex } from "@redotech/arbiter/flex";
import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { RedoModal } from "@redotech/arbiter/modal/redo-modal";
import { useRequiredContext } from "@redotech/react-util/context";
import UserPlus01Icon from "@redotech/redo-icons/user-plus-01.svg";
import { clientErrorMessage } from "@redotech/rpc/errors";
import { memo, useState } from "react";

import { RedoAdminRpcClientContext } from "../app/redo-admin-rpc-client-provider";

export const AddPartnerUserModal = memo(function AddPartnerUserModal({
  partnerId,
  partnerName,
  onClose,
  onAdded,
}: {
  partnerId: string;
  partnerName: string;
  onClose: () => void;
  onAdded: () => void;
}) {
  const rpcClient = useRequiredContext(RedoAdminRpcClientContext);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState<string | undefined>();
  const [submitting, setSubmitting] = useState(false);
  const input = createPartnerUser.input.safeParse({
    partnerId,
    email,
    name: name.trim() || undefined,
  });

  const submit = async () => {
    if (!input.success) {
      return;
    }
    setSubmitting(true);
    setError(undefined);
    try {
      await rpcClient.createPartnerUser(input.data);
      onAdded();
    } catch (err) {
      setError(clientErrorMessage(err, "Couldn't add the user."));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <RedoModal
      onModalCloseRequested={onClose}
      primaryButton={{
        text: "Add user",
        disabled: !input.success || submitting,
        onClick: submit,
      }}
      secondaryButton={{ text: "Cancel", onClick: onClose }}
      subtitle={`They sign in to the partner portal with a magic link sent to this email, and act for ${partnerName}.`}
      title="Add portal user"
      TitleIcon={UserPlus01Icon}
    >
      <Flex dir="column" gap="lg">
        <RedoTextInput
          autoFocus
          description="Check this address carefully. Anyone who can read its inbox can sign in to the portal as this user."
          errorText={error}
          fullWidth
          inputTypeHint="email"
          label="Email"
          placeholder="pat@zonos.com"
          setValue={setEmail}
          value={email}
        />
        <RedoTextInput
          fullWidth
          label="Name (optional)"
          placeholder="Pat Lee"
          setValue={setName}
          value={name}
        />
      </Flex>
    </RedoModal>
  );
});
